import React from 'react';
import Me from './components/Me.js';

import About from './components/About';
import Contact from './components/Contact.js';
import Portfolio from './components/Portfolio.js';
import Picture from './components/Picture.js'
import Colophon from './components/Colophon.js';


import './styles.css';

const Home = () => {
    return (
        <div className="Home">
            <header className="masthead">
                <Picture />
                <div className="masthead-text">
                    <Me />
                </div>
            </header>
            <About />
            <Contact />
            <Portfolio />
            <Colophon />
        </div>
    );
};

export default Home;
